/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIRequestFile
 */
export interface APIRequestFile {
    /**
     * 
     * @type {string}
     * @memberof APIRequestFile
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestFile
     */
    request: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestFile
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIRequestFile
     */
    document?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIRequestFile
     */
    readonly name: string;
    /**
     * 
     * @type {Date}
     * @memberof APIRequestFile
     */
    readonly storedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIRequestFile
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof APIRequestFile
     */
    readonly size: number;
}

/**
 * Check if a given object implements the APIRequestFile interface.
 */
export function instanceOfAPIRequestFile(value: object): value is APIRequestFile {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('request' in value) || value['request'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('storedAt' in value) || value['storedAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function APIRequestFileFromJSON(json: any): APIRequestFile {
    return APIRequestFileFromJSONTyped(json, false);
}

export function APIRequestFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequestFile {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'request': json['request'],
        'key': json['key'] == null ? undefined : json['key'],
        'document': json['document'] == null ? undefined : json['document'],
        'name': json['name'],
        'storedAt': (new Date(json['stored_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'size': json['size'],
    };
}

export function APIRequestFileToJSON(value?: Omit<APIRequestFile, 'self'|'name'|'stored_at'|'last_modified_at'|'size'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'request': value['request'],
        'key': value['key'],
        'document': value['document'],
    };
}

